module.exports = __webpack_public_path__ + "img/کارت-ویزیت-لمینت-مات.c4ebc306.png";